/* EditAction.js */

"use strict";

const _ = require("lodash");

class EditAction {
    constructor(logger, gameEditor, OsImageCatalog, activeView) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osCatalogEntity = OsImageCatalog;
        this._activeView = activeView;
        this.run = this.run.bind(this);
    }
    run() {
        return Promise.resolve().then(() => {
            let seletedCatalogIds = _.get(
                this._activeView.getSelectedCatalogIds(),
                "selectedRows",
                []
            );
            this._activeView.openOsCatalogInstanceEditor(seletedCatalogIds);
        });
    }
}
module.exports = EditAction;

EditAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.entities.OsImageCatalog",
    "gameEditor.activeView",
];

EditAction.$displayDetails = {
    type: "Action",
    name: "EditAction",
    icon: "osmanager.edit_os_catalog",
    shown: true,
    title: "Edit Entry",
    order: 2,
};
